import { apiFetch } from "~/lib/fetchClient";

export const isCustomFieldsUnavailable = (error) =>
  error?.status === 403 && error?.code === "custom_fields_unavailable";

export class CustomFieldsRequestError extends Error {
  constructor({
    status = null,
    code = null,
    errors = null,
    details = null,
    uncertain = false,
  }) {
    super(
      uncertain
        ? "The save outcome is unknown. Reload and review before submitting again."
        : "The request could not be completed.",
    );
    this.name = "CustomFieldsRequestError";
    this.status = status;
    this.code = code;
    this.errors = errors;
    this.details = details;
    this.uncertain = uncertain;
  }
}

/** Capture identity at dispatch; never replay a failed mutation. */
export const customFieldsRequest = async ({
  teamId,
  path,
  method = "GET",
  body,
  signal,
  handleUnavailable = false,
}) => {
  const mutation = method !== "GET";
  try {
    const response = await apiFetch.raw(path, {
      method,
      headers: { team: String(teamId) },
      signal,
      ...(handleUnavailable
        ? { handledForbiddenCodes: ["custom_fields_unavailable"] }
        : {}),
      ...(body === undefined ? {} : { json: body }),
    });
    const text = await response.text();
    let payload = null;
    try {
      payload = text ? JSON.parse(text) : null;
    } catch {
      throw new CustomFieldsRequestError({
        status: response.status,
        uncertain: mutation && (response.ok || response.status >= 500),
      });
    }
    if (!response.ok || payload?.errors) {
      throw new CustomFieldsRequestError({
        status: response.status,
        code: payload?.code || payload?.error,
        errors: payload?.errors,
        details: payload,
        uncertain: mutation && response.status >= 500,
      });
    }
    return payload;
  } catch (error) {
    if (error instanceof CustomFieldsRequestError) {
      throw error;
    }
    throw new CustomFieldsRequestError({ uncertain: mutation });
  }
};
